/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `OrderCheckIn.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { OrderCheckIn } from "./OrderCheckIn";

import { Audit } from "./Audit";
import { Order } from "./Order";
import { User } from "./User";

export abstract class OrderCheckInModel {
    id: number;
    comments: string | null;
    createdAt: Dayjs;
    orderId: number | null;
    response: number | null;
    updatedAt: Dayjs;
    userId: number | null;
    audits: Audit[] | undefined;
    order: Order | null | undefined;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        comments: string | null,
        createdAt: Dayjs,
        orderId: number | null,
        response: number | null,
        updatedAt: Dayjs,
        userId: number | null,
        audits: Audit[] | undefined,
        order: Order | null | undefined,
        user: User | null | undefined
    ) {
        this.id = id;
        this.comments = comments;
        this.createdAt = createdAt;
        this.orderId = orderId;
        this.response = response;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.audits = audits;
        this.order = order;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): OrderCheckIn {
        const newObject = new OrderCheckIn(
            json["id"],
            json["comments"],
            dayjs(json["created_at"]).tz(timezone),
            json["order_id"],
            json["response"],
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["audits"]?.map((item: any) => Audit.fromApiObject(item, timezone)),
            json["order"] == null ? json["order"] : Order.fromApiObject(json["order"], timezone),
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            comments: this.comments,
            created_at: this.createdAt,
            order_id: this.orderId,
            response: this.response,
            updated_at: this.updatedAt,
            user_id: this.userId,
            audits: this.audits?.map((item) => item.toApiObject(visited)).filter((item) => item !== undefined),
            order_attributes: this.order?.toApiObject(visited),
            user_attributes: this.user?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): OrderCheckIn {
        const clone = Object.create(this) as OrderCheckIn;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
